import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { capitalizeString, toggleBodyClass } from '../../../utils/jsUtils';

import constants from '../../../config/constants';
import { noop } from '../../../utils/noop';
import WithOutsideClick from '../../../utils/WithOutsideClick';
import SubMenu from '../../Availability/DeliveryOptions/SubMenu';
import BackgroundOverlay from '../BackgroundOverlay/BackgroundOverlay';
import DeliveryMethodSelector from '../DeliveryMethodSelector/DeliveryMethodSelector';
import MarketplaceSpinner from '../Spinner/MarketplaceSpinner';
import { SideDrawerStyles, SideDrawerStylesGlobal } from './SideDrawer.styles';

const SideDrawer = ({
  toggleState,
  width = '400px',
  height = '100%',
  heading,
  modalBusy,
  comunData,
  availabilityList,
  type,
  selectedType,
  screen,
  view,
  isMapView,
  onCambiar,
  setIsMapView,
  setView,
  setSelectedType,
  children,
  isError,
  deliveryActions,
}) => {
  const [isDrawerActive, activateDrawer] = toggleState;

  useEffect(() => {
    toggleBodyClass(isDrawerActive, 'drawer-active');
    toggleBodyClass(true, 'no-scroll');
    return () => {
      toggleBodyClass(false, 'drawer-active');
      toggleBodyClass(false, 'no-scroll');
    };
  }, [isDrawerActive]);

  const { comunaName, regionName } = comunData || {};

  const shouldRender = () => {
    const zoneMenu = (screen === 'screen3' && type === constants.AVAILABILITY_HOMEDELIVERY) || screen !== 'screen1';
    const viewButtons =
      screen !== 'screen3' ||
      (screen === 'screen3' && selectedType === constants.AVAILABILITY_HOMEDELIVERY) ||
      (screen === 'screen3' && isError[selectedType].isError);
    return {
      zoneMenu,
      viewButtons,
    };
  };

  if (!isDrawerActive) {
    return null;
  }

  return createPortal(
    <div>
      <BackgroundOverlay />
      <div
        className={cx('right-drawer-container', isDrawerActive && 'is-open')}
        style={{
          transform: `translateX(${isDrawerActive ? '0' : width})`,
          width,
          height,
        }}
        role="dialog"
        aria-modal="true"
        aria-labelledby={heading ? 'drawer-heading' : undefined}
      >
        <WithOutsideClick onOutsideClick={() => activateDrawer(false)}>
          <div
            className={cx(
              'right-drawer-header',
              isMapView && 'zone-header-screen',
              screen === 'screen1' && 'no-border'
            )}
          >
            <button
              className="drawer-line"
              onClick={() => activateDrawer(false)}
              onKeyDown={noop}
              type="button"
              tabIndex={0}
            />
            {screen !== 'screen1' && (
              <>
                <div className="close-drawer">
                  <button
                    type="button"
                    className="close-button"
                    onClick={() => activateDrawer(false)}
                    aria-label="Cerrar"
                  >
                    <i className={cx('csicon-danger', isMapView && 'close-icon-screen')} />
                  </button>
                </div>
                <DeliveryMethodSelector
                  availabilityList={availabilityList}
                  isMapView={isMapView}
                  type={selectedType}
                  setSelectedType={setSelectedType}
                  setIsMapView={setIsMapView}
                  setView={setView}
                  deliveryActions={deliveryActions}
                />
                <SubMenu
                  onCambiar={onCambiar}
                  isMapView={isMapView}
                  view={view}
                  setIsMapView={setIsMapView}
                  setView={setView}
                  comunaName={capitalizeString(comunaName)}
                  regionName={capitalizeString(regionName)}
                  shouldRender={shouldRender()}
                />
              </>
            )}
          </div>

          <div className="right-drawer-content">
            {modalBusy && (
              <div className="drawer-busy-overlay">
                <MarketplaceSpinner />
              </div>
            )}
            {children}
          </div>
        </WithOutsideClick>
        <style jsx>{SideDrawerStyles}</style>
        <style jsx>{SideDrawerStylesGlobal}</style>
      </div>
    </div>,
    document.body
  );
};

SideDrawer.propTypes = {
  toggleState: PropTypes.array.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node.isRequired,
  heading: PropTypes.bool.isRequired,
  modalBusy: PropTypes.bool.isRequired,
  comunData: PropTypes.object.isRequired,
  onCambiar: PropTypes.func.isRequired,
  availabilityList: PropTypes.array.isRequired,
  screen: PropTypes.string.isRequired,
  isMapView: PropTypes.bool.isRequired,
  setIsMapView: PropTypes.func.isRequired,
  view: PropTypes.string.isRequired,
  setView: PropTypes.func.isRequired,
  height: PropTypes.string,
  selectedType: PropTypes.string.isRequired,
  setSelectedType: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  isError: PropTypes.object.isRequired,
  deliveryActions: PropTypes.object.isRequired,
};

SideDrawer.defaultProps = {
  width: '400px',
  height: '100%',
};

export default SideDrawer;
